import React from 'react'
import clsx from 'clsx'
import { parseMentionContent } from './mentionUtils'

export interface MentionTextProps {
  content: string
  className?: string
}

const MentionText: React.FC<MentionTextProps> = ({ content, className }) => {
  const parts = parseMentionContent(content)

  return (
    <span className={clsx('whitespace-pre-wrap break-words', className)}>
      {parts.map((part, index) => {
        if (part.type === 'text') {
          return <React.Fragment key={index}>{part.value}</React.Fragment>
        }
        return (
          <span
            key={index}
            className="font-medium text-primary-600 dark:text-primary-400"
            title={`@${part.name}`}
          >
            @{part.name}
          </span>
        )
      })}
    </span>
  )
}

export default MentionText
